import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth'
import { getFirestore } from "firebase/firestore";

const productionFallbackConfig = {
  apiKey: "AIzaSyAvPGHyaph4X4MyLkzggBH3q0U7w3NgCQU",
  authDomain: "barber-project-d75f8.firebaseapp.com",
  databaseURL: "https://barber-project-d75f8-default-rtdb.firebaseio.com",
  projectId: "barber-project-d75f8",
  storageBucket: "barber-project-d75f8.appspot.com",
  messagingSenderId: "122062340578",
  appId: "1:122062340578:web:31fc3c1453fef4b79c79bb"
};

const hasEnvironmentConfig = Boolean(process.env.REACT_APP_FIREBASE_PROJECT_ID);

const environmentConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL || undefined,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const firebaseConfig = hasEnvironmentConfig ? environmentConfig : productionFallbackConfig;

if (process.env.NODE_ENV === 'development') {
  console.info(`Firebase project: ${firebaseConfig.projectId}`);
}

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);

export const db = getFirestore(app);
